var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',_vm._b({staticClass:"logo text-center"},'h1',_vm.$attrs,false),[_c('img',{attrs:{"src":require("@/assets/images/logo.png"),"width":_vm.width,"alt":_vm.title}})])
}
var staticRenderFns = []

export { render, staticRenderFns }